import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*
* 部屋タイプ 定数
*
*/
export const HTYPE = {
  PORCH: 1, /* ポーチ */
  HALLWAY: 2, /* 廊下 */
  ENTRANCE: 3, /* 玄関 */
  LIVING: 4, /* リビング */
  DINING: 5, /* ダイニング */
  KITCHEN: 6, /* キッチン */
  WASHROOM: 7, /* 洗面 */
  TOILET: 8, /* トイレ */
  BATHROOM: 9, /* 浴室 */
  FLORING: 10, /* 洋室 */
  WASITU: 11, /* 和室 */
  TOKONOMA: 12, /* 床の間 */
  HIROEN: 13, /* 広縁 */
  CLOSET: 14, /* 収納 */
  STAIR: 16, /* 階段 */
  WELLHOLE: 17, /* 吹き抜け */
  BALCONY: 18, /* バルコニー */
  LD: 25, /* LD */
  LDK: 26, /* LDK */
  GARAGE: 27, /* 車庫 */
  DOMA: 28, /* 土間 */
  UNKNOWN: -1,
};

/** *****************************************************
*******************************************************
* floor COLOR                             RoomColor.xml
*/
export class FloorColor {
  public id: string;

  public type: string;

  public code: number;

  public color: string;

  public name: string;

  constructor() {
    this.id = '';
    this.type = '';
    this.code = 0;
    this.color = '';
    this.name = '';
  }

  public IsHit(item: string): boolean {
    if (this.id === item) return true;
    return false;
  }

  public readXML(item: any): void {
    const rattr = item.attributes;
    this.id = rattr.getNamedItem('id').nodeValue;
    this.type = rattr.getNamedItem('type').nodeValue;
    this.color = rattr.getNamedItem('color').nodeValue;
    this.code = Number(rattr.getNamedItem('code').nodeValue);
    this.name = item.textContent;
  }
}

/** *****************************************************
*******************************************************
* SYSTEM COLOR access propaty
*/
export class AutoColor {
  public attr: Array<FloorColor>;

  constructor() {
    this.attr = [];
  }

  public Add(item: FloorColor) {
    this.attr.push(item);
  }

  public Clear() {
    this.attr.splice(0, this.attr.length);
  }

  public RoomColor(item: string): string {
    for (let i = 0; i < this.attr.length; i += 1) {
      if (this.attr[i].IsHit(item) === true) {
        return this.attr[i].color;
      }
    }
    return '#000';
  }

  public RoomName(item: string): string {
    for (let i = 0; i < this.attr.length; i += 1) {
      if (this.attr[i].IsHit(item) === true) {
        return this.attr[i].name;
      }
    }
    return '';
  }

  public RoomCode(item: any): number {
    for (let i = 0; i < this.attr.length; i += 1) {
      if (this.attr[i].IsHit(item) === true) {
        return this.attr[i].code;
      }
    }
    return -1;
  }
}

/*
*
* new AutoRoom( "","",0,null,0);
*/
export class AutoObjRoom {
    public item: string;

    public name: string;

    public textPt: marietta.core.Point;

    public textAuto: boolean;

    public textJyou: boolean;

    public textVisible: boolean;

    public index: number;

    public guid: string;

    public color: number;

    public points: marietta3d.AutoGen.utils.RoomPointArray;

    public flr: number;

    public visible: boolean;

    public roukaEnable: boolean;

    public original: string;

    constructor(item: string, name: string, index: number, guid: string, ary: marietta3d.AutoGen.utils.RoomPointArray, flr: number) {
      this.item = item;
      this.name = name;
      this.textPt = new marietta.core.Point(0, 0, 0);
      this.textAuto = true;
      this.textJyou = false;
      this.textVisible = true;
      this.index = index;
      this.guid = guid;
      this.color = 0;
      this.points = ary;
      this.flr = flr;
      this.visible = true;
      this.roukaEnable = false; /* 廊下自動生成で有効な廊下の時 true */
      this.original = '0';
    }

    /*
    * HTYPE Name
    *
    */
    public static htypeName(type: number): string {
      let name: string;
      switch (type) {
        case HTYPE.BALCONY: name = 'バルコニー'; break;
        case HTYPE.BATHROOM: name = '浴室'; break;
        case HTYPE.CLOSET: name = '収納'; break;
        case HTYPE.DINING: name = 'ダイニング'; break;
        case HTYPE.ENTRANCE: name = '玄関'; break;
        case HTYPE.FLORING: name = '洋室'; break;
        case HTYPE.HALLWAY: name = '廊下'; break;
        case HTYPE.KITCHEN: name = 'キッチン'; break;
        case HTYPE.LIVING: name = 'リビング'; break;
        case HTYPE.PORCH: name = 'ポーチ'; break;
        case HTYPE.STAIR: name = '階段'; break;
        case HTYPE.TOILET: name = 'トイレ'; break;
        case HTYPE.TOKONOMA: name = '床の間'; break;
        case HTYPE.HIROEN: name = '広縁'; break;
        case HTYPE.WASHROOM: name = '洗面'; break;
        case HTYPE.WASITU: name = '和室'; break;
        case HTYPE.WELLHOLE: name = '吹抜'; break;
        case HTYPE.LD: name = 'LD'; break;
        case HTYPE.LDK: name = 'LDK'; break;
        case HTYPE.GARAGE: name = '車庫'; break;
        case HTYPE.DOMA: name = '土間'; break;
        case HTYPE.UNKNOWN: name = '外部'; break;
        default: break;
      }
      return name;
    }

    /*
    */
    public SetEnable(flag: boolean) {
      this.roukaEnable = flag;
    }

    /*
    */
    public GetEnable(): boolean {
      return this.roukaEnable;
    }

    /*
    */
    public IsPorch(): boolean {
      if (this.item.indexOf('rom01') >= 0) { /* ポーチ */
        return true;
      }
      return false;
    }

    /*
    */
    public IsHallway(): boolean {
      if (this.item.indexOf('rom02') >= 0) { /* 廊下 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsEntrance(): boolean {
      if (this.item.indexOf('rom03') >= 0) { /* 玄関 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsLiving(): boolean {
      if (this.item.indexOf('rom04') >= 0) { /* リビング */
        return true;
      }
      return false;
    }

    /*
    */
    public IsDining(): boolean {
      if (this.item.indexOf('rom05') >= 0) { /* ダイニング */
        return true;
      }
      return false;
    }

    /*
    */
    public IsKitchen(): boolean {
      if (this.item.indexOf('rom06') >= 0) { /* キッチン */
        return true;
      }
      return false;
    }

    /*
    */
    public IsWashroom(): boolean {
      if (this.item.indexOf('rom07') >= 0) { /* 洗面 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsToilet(): boolean {
      if (this.item.indexOf('rom08') >= 0) { /* トイレ */
        return true;
      }
      return false;
    }

    /*
    */
    public IsBathroom(): boolean {
      if (this.item.indexOf('rom09') >= 0) { /* 浴室 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsFloring(): boolean {
      if (this.item.indexOf('rom10') >= 0) { /* 洋室 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsWasitu(): boolean {
      if (this.item.indexOf('rom11') >= 0) { /* 和室 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsTokonoma(): boolean {
      if (this.item.indexOf('rom12') >= 0) { /* 床の間 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsHiroen(): boolean {
      if (this.item.indexOf('rom13') >= 0) { /* 広縁 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsCloset(): boolean {
      if ((this.item.indexOf('rom14') >= 0) /* 収納 */
            || (this.item.indexOf('rom24') >= 0)) { /* WIC */
        return true;
      }
      return false;
    }

    /*
    */
    public IsStudy(): boolean {
      if (this.item.indexOf('rom15') >= 0) { /* 書斎 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsStair(): boolean {
      if (this.item.indexOf('rom16') >= 0) { /* 階段 */
        return true;
      }
      return false;
    }

    /*
    */
    public IsWellhole(): boolean {
      if (this.item.indexOf('rom17') >= 0) { /* 吹き抜け */
        return true;
      }
      return false;
    }

    /*
    */
    public IsBalcony(): boolean {
      if (this.item.indexOf('rom18') >= 0) { /* バルコニー */
        return true;
      }
      return false;
    }

    /*
    */
    public IsLD(): boolean {
      if (this.item.indexOf('rom25') >= 0) { /* LD */
        return true;
      }
      return false;
    }

    /*
    */
    public IsLDK(): boolean {
      if (this.item.indexOf('rom26') >= 0) { /* LDK */
        return true;
      }
      return false;
    }

    /*
    */
    public IsGarage(): boolean {
      if (this.item.indexOf('rom27') >= 0) { /* ガレージ */
        return true;
      }
      return false;
    }

    /*
    */
    public IsDoma(): boolean {
      if (this.item.indexOf('rom28') >= 0) { /* 土間 */
        return true;
      }
      return false;
    }

    /*
    */
    public HeyaType(): number {
      if (this.IsPorch() === true) return HTYPE.PORCH;
      if (this.IsHallway() === true) return HTYPE.HALLWAY;
      if (this.IsEntrance() === true) return HTYPE.ENTRANCE;
      if (this.IsLiving() === true) return HTYPE.LIVING;
      if (this.IsDining() === true) return HTYPE.DINING;
      if (this.IsKitchen() === true) return HTYPE.KITCHEN;
      if (this.IsWashroom() === true) return HTYPE.WASHROOM;
      if (this.IsBathroom() === true) return HTYPE.BATHROOM;
      if (this.IsFloring() === true) return HTYPE.FLORING;
      if (this.IsWasitu() === true) return HTYPE.WASITU;
      if (this.IsBalcony() === true) return HTYPE.BALCONY;
      if (this.IsTokonoma() === true) return HTYPE.TOKONOMA;
      if (this.IsHiroen() === true) return HTYPE.HIROEN;
      if (this.IsCloset() === true) return HTYPE.CLOSET;
      if (this.IsToilet() === true) return HTYPE.TOILET;
      if (this.IsStair() === true) return HTYPE.STAIR;
      if (this.IsWellhole() === true) return HTYPE.WELLHOLE;
      if (this.IsLD() === true) return HTYPE.LD;
      if (this.IsLDK() === true) return HTYPE.LDK;
      if (this.IsGarage() === true) return HTYPE.GARAGE;
      if (this.IsDoma() === true) return HTYPE.DOMA;
      return HTYPE.UNKNOWN; // わからない
    }

    /*
    * 点が部屋の領域に含まれるとき true
    */
    public IsHit(p: marietta.core.Point): boolean {
      let rc: any;
      try {
        rc = this.points.IsInclude(p);
      } catch (e) {
        // エラーに関係なく続行
      }
      if (rc === 1) {
        return true;
      }
      return false;
    }

    /*
    * 部屋の頂点座標をオフセットする
    */
    public Move(x: number, y: number): void {
      this.points.Move(x, y);
    }

    /*
    * 描画
    */
    public draw(sc: marietta3d.AutoGen.Scale, ctx: CanvasRenderingContext2D, sysColor: AutoColor): void {
      if (this.points.length > 1) {
        let cl = '#ccc';
        cl = sysColor.RoomColor(this.item);
        const p0 = sc.ConvertToCanvas(this.points[0]);
        ctx.beginPath();
        ctx.fillStyle = cl;
        ctx.strokeStyle = cl;
        ctx.lineWidth = 1;
        ctx.moveTo(p0.x, p0.y);
        for (let i = 1; i < this.points.length; i += 1) {
          const p = sc.ConvertToCanvas(this.points[i]);
          ctx.lineTo(p.x, p.y);
        }
        // ctx.lineTo(p0.x, p0.y);
        ctx.closePath();
        ctx.fill();
      }
    }

    /*
    * XMLの書き出し
    */
    public createXML(/* cnt: number */): string {
      let xml = '';
      const v = (this.textVisible === true) ? '1' : '0';
      const j = (this.textJyou === true) ? '1' : '0';
      const a = (this.textAuto === true) ? '1' : '0';
      xml = `${xml}<item id="${this.item}" f="${this.flr.toString()}" index="${this.index.toString()}" guid="${this.guid.toString()}">\n`;
      xml = `${xml}<text x="${this.textPt.x.toString()}" y="${this.textPt.y.toString()}" visible="${v}" auto_layout="${a}" area_use_jyou="${j}">`;
      xml = `${xml + this.name}</text>\n`;
      xml += '<shape>\n';
      for (let i = 0; i < this.points.length; i += 1) {
        const p = this.points[i];
        const num = (i + 1).toString();
        xml = `${xml}<point wall_type="${p.flag.toString()}" index="${num}" x="${p.x.toString()}" y="${p.y.toString()}"/>\n`;
      }
      xml += '</shape>\n';
      xml += '</item>\n';
      return xml;
    }

    /*
    * XMLの書き出し
    */
    public createXML2(doc: Document, nodeRoom: Element/* , cnt: number */) {
      const v = (this.textVisible === true) ? '1' : '0';
      const j = (this.textJyou === true) ? '1' : '0';
      const a = (this.textAuto === true) ? '1' : '0';

      const nodeItem = doc.createElement('item');
      nodeRoom.appendChild(nodeItem);

      nodeItem.setAttribute('id', this.item);
      nodeItem.setAttribute('f', this.flr.toString());
      nodeItem.setAttribute('index', this.index.toString());
      nodeItem.setAttribute('guid', this.guid.toString());

      const nodeText = doc.createElement('text');
      nodeItem.appendChild(nodeText);

      nodeText.setAttribute('x', this.textPt.x.toString());
      nodeText.setAttribute('y', this.textPt.y.toString());
      nodeText.setAttribute('visible', v);
      nodeText.setAttribute('auto_layout', a);
      nodeText.setAttribute('area_use_jyou', j);
      nodeText.textContent = this.name;

      const nodeShape = doc.createElement('shape');
      nodeItem.appendChild(nodeShape);

      for (let i = 0; i < this.points.length; i += 1) {
        const p = this.points[i];
        const num = (i + 1).toString();

        const nodeP = doc.createElement('point');
        nodeShape.appendChild(nodeP);

        nodeP.setAttribute('index', num);
        nodeP.setAttribute('x', p.x.toString());
        nodeP.setAttribute('y', p.y.toString());
        nodeP.setAttribute('wall_type', p.flag.toString());
      }
    }

    /*
    * XMLの読み込み
    */
    public readXML(item: any) {
      let n = '';
      let elem: any;
      // item
      const rattr = item.attributes;
      this.flr = Number(rattr.getNamedItem('f').nodeValue);
      this.index = Number(rattr.getNamedItem('index').nodeValue);
      this.item = rattr.getNamedItem('id').nodeValue;

      const nodeCI = rattr.getNamedItem('guid');
      if (nodeCI != null) {
        this.guid = nodeCI.nodeValue;
      } else {
        this.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      elem = rattr.getNamedItem('original');
      if (elem != null) {
        this.original = elem.nodeValue;
      }

      this.color = 0;
      elem = rattr.getNamedItem('color');
      if (elem != null) {
        this.color = Number(elem.nodeValue);
      }
      /* let design_color: number = 0;
      elem = rattr.getNamedItem('design_color');
      if (elem != null) {
        design_color = Number(elem.nodeValue);
      }
      let koshi: number = 0;
      elem = rattr.getNamedItem('koshi');
      if (elem != null) {
        koshi = Number(elem.nodeValue);
      }
      let design_type: number = 0;
      elem = rattr.getNamedItem('design_type');
      if (elem != null) {
        design_type = Number(elem.nodeValue);
      } */

      // text
      const name = item.getElementsByTagName('text');
      if (name != null) {
        const textattr = name[0].attributes;
        const textX = Number(textattr.getNamedItem('x').nodeValue);
        const textY = Number(textattr.getNamedItem('y').nodeValue);
        this.textPt = new marietta.core.Point(textX, textY, 0);
        let textJyou = 0;
        elem = textattr.getNamedItem('area_use_jyou');
        if (elem != null) {
          textJyou = Number(elem.nodeValue);
        }
        let textVisible = 0;
        elem = textattr.getNamedItem('visible');
        if (elem != null) {
          textVisible = Number(elem.nodeValue);
        }
        let textAuto = 0;
        elem = textattr.getNamedItem('auto_layout');
        if (elem != null) {
          textAuto = Number(elem.nodeValue);
        }
        this.textAuto = textAuto !== 0;
        this.textJyou = textJyou !== 0;
        this.textVisible = textVisible !== 0;
        this.name = name[0].textContent;
        n = `[${this.name}], `;
      }
      // shape
      const shape = item.getElementsByTagName('shape');
      const points = shape[0].getElementsByTagName('point');

      this.points = new marietta3d.AutoGen.utils.RoomPointArray();
      for (let j = 0; j < points.length; j += 1) {
        const pt = points[j].attributes;
        const ptx: number = Number(pt.getNamedItem('x').nodeValue);
        const pty: number = Number(pt.getNamedItem('y').nodeValue);
        const ptf: number = Number(pt.getNamedItem('wall_type').nodeValue);
        this.points.Add(new marietta.core.Point(ptx, pty, ptf));
      }
      return n;
    }

    /*
    * jsonの読み込み
    */
    public readJson(item: any, buildingType:number = null) {
      let n = '';
      let elem: any;
      this.flr = Number(item.f);
      this.index = Number(item.index);
      this.item = item.id;

      if (item.guid !== undefined) {
        this.guid = item.guid;
      } else {
        this.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      if (item.original !== undefined) {
        this.original = item.original;
      }

      this.color = 0;
      if (item.color !== undefined) {
        this.color = Number(item.color);
      }

      // text
      const name = item.text;
      if (name != null) {
        let textX = Number(name.x);
        let textY = Number(name.y);
        if (buildingType !== null && buildingType === 1) {
          textX = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(name.x));
          textY = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(name.y));
        }
        this.textPt = new marietta.core.Point(textX, textY, 0);
        let textJyou = 0;
        if (name.area_use_jyou != null) {
          textJyou = Number(name.area_use_jyou);
        }
        let textVisible = 0;
        if (name.visible != null) {
          textVisible = Number(name.visible);
        }
        let textAuto = 0;
        if (name.auto_layout != null) {
          textAuto = Number(name.auto_layout);
        }
        this.textAuto = textAuto !== 0;
        this.textJyou = textJyou !== 0;
        this.textVisible = textVisible !== 0;
        this.name = name.textContent;
        n = `[${this.name}], `;
      }
      // shape
      const shapeList = item.shape;
      this.points = new marietta3d.AutoGen.utils.RoomPointArray();
      for (let j = 0; j < shapeList.length; j += 1) {
        let ptx: number = Number(shapeList[j].x);
        let pty: number = Number(shapeList[j].y);
        if (buildingType !== null && buildingType === 1) {
          ptx = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(shapeList[j].x));
          pty = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(shapeList[j].y));
        }
        const ptf: number = Number(shapeList[j].wall_type);
        this.points.Add(new marietta.core.Point(ptx, pty, ptf));
      }
      return n;
    }
}
